import React from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';

export default function AssessmentLoader({ progress }) {
  return (
    <div style={{ textAlign: 'center', marginTop: '15%' }}>
      <h4 style={{ margin: '20px' }}>Please wait, this may take a while</h4>
      <ProgressBar
        now={progress}
        striped
        animated
        variant="danger"
        label={`${progress}%`}
      />
    </div>
  );
}
